"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6114],{

/***/ 6447:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/repareo.38e626de.svg","height":35,"width":136});

/***/ }),

/***/ 2296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ AdacPartnerLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/assets/images/adac-partnerLogo.svg
/* harmony default export */ var adac_partnerLogo = ({"src":"/_next/static/media/adac-partnerLogo.403ad4e0.svg","height":30,"width":100});
;// CONCATENATED MODULE: ./components/Home/ContentElements/PartnerHeaderLogos/AdacPartnerLogo.tsx






var AdacPartnerLogo = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AdacPartnerLogo, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AdacPartnerLogo);
    function AdacPartnerLogo() {
        (0,_class_call_check/* default */.Z)(this, AdacPartnerLogo);
        return _super.apply(this, arguments);
    }
    var _proto = AdacPartnerLogo.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full my-0 mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: adac_partnerLogo.src,
                    alt: "ADAC Partner",
                    width: "100",
                    height: "30"
                })
            })
        });
    };
    return AdacPartnerLogo;
}(react.PureComponent);


/***/ }),

/***/ 7183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ MehrmarkencenterLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/assets/images/logo-mehrmarken-center.jpg
/* harmony default export */ var logo_mehrmarken_center = ({"src":"/_next/static/media/logo-mehrmarken-center.2c3a2fff.jpg","height":78,"width":270,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAIACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAAAQEBAQAAAAAAAAAAAAAAAAAAAgT/2gAMAwEAAhADEAAAAIHN/8QAGRAAAQUAAAAAAAAAAAAAAAAAAQAFNHGx/9oACAEBAAE/AG2IbOL/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQMzcv/aAAgBAgEBPwB3TaP/xAAXEQEAAwAAAAAAAAAAAAAAAAACADJx/9oACAEDAQE/ADQZP//Z","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./components/Home/ContentElements/PartnerHeaderLogos/MerhmarkencenterLogo.tsx






var MehrmarkencenterLogo = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MehrmarkencenterLogo, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MehrmarkencenterLogo);
    function MehrmarkencenterLogo() {
        (0,_class_call_check/* default */.Z)(this, MehrmarkencenterLogo);
        return _super.apply(this, arguments);
    }
    var _proto = MehrmarkencenterLogo.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full my-0 mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: logo_mehrmarken_center.src,
                    alt: "Mehrmarkencenter",
                    width: "124",
                    height: "35"
                })
            })
        });
    };
    return MehrmarkencenterLogo;
}(react.PureComponent);


/***/ }),

/***/ 8427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var HeaderNavigation = function(param) {
    var children = param.children;
    var onlyOne = function onlyOne(checkboxID) {
        var checkboxes = document.getElementsByName("navCheck");
        var checkbox = document.getElementById(checkboxID);
        var isMobile = window.innerWidth < 976;
        checkboxes.forEach(function(item) {
            if (item !== checkbox && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(item, HTMLInputElement) && !isMobile) item.checked = false;
        });
    };
    var toggleDropdowns = function toggleDropdowns(showCarsale, showServices) {
        var isMobile = window.innerWidth < 976;
        if (!isMobile) {
            setcarsaleIsShowing(showCarsale);
            setservicesIsShowing(showServices);
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), carsaleIsShowing = ref[0], setcarsaleIsShowing = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), servicesIsShowing = ref1[0], setservicesIsShowing = ref1[1];
    var services = [
        {
            name: "Inspektion",
            href: "https://www.repareo.de/inspektion/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-car-wrench-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "HU/AU",
            href: "https://www.repareo.de/hauptuntersuchung-hu-au/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-clipboard-list-check-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "\xd6lwechsel",
            href: "https://www.repareo.de/oelwechsel/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-oil-can-drip-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Reifen&shy;wechsel",
            href: "https://www.repareo.de/reifenwechsel/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-tire-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Zahnriemen&shy;wechsel",
            href: "https://www.repareo.de/zahnriemenwechsel/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-engine-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Kupplungs&shy;wechsel",
            href: "https://www.repareo.de/kupplung-wechseln/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-gears-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Klima&shy;service",
            href: "https://www.repareo.de/klimaservice/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-temperature-snow-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Bremsen&shy;wechsel",
            href: "https://www.repareo.de/bremsen-wechseln/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-bagel-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Querlenker wechseln",
            href: "https://www.repareo.de/querlenker-wechseln/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-steering-wheel-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Motor&shy;tausch",
            href: "https://www.repareo.de/austauschmotor/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-engine-warning-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Motor&shy;schaden",
            href: "https://www.repareo.de/motorschaden/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-engine-warning-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Glas&shy;reparatur",
            href: "https://www.repareo.de/autoscheibe/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-gears-light font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        }, 
    ];
    var carsale = [
        {
            name: "Auto&shy;bewertung",
            href: "https://www.repareo.de/autobewertung-kostenlos/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-car font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Auto&shy;ankauf",
            href: "https://www.repareo.de/auto-verkaufen/",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-car font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Unfall&shy;gutachten",
            href: "https://lp.repareo.de/gutachten/unfallgutachten-tuv-rheinland",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-car-burst font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        },
        {
            name: "Wert&shy;gutachten",
            href: "https://lp.repareo.de/gutachten/wertgutachten-tuv-rheinland",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fa-kit fa-certificate font-normal fa-fw text-primary text-2xl mr-3 align-middle"
            })
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "subPageNav",
        id: "nav-open",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "navigation px-6 lg:bg-white -ml-6 lg:ml-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "lg:flex items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: servicesIsShowing ? " lg:text-gray-900 lg:ring-2 lg:ring-primary-500 lg:ring-offset-2 lg:outline-none lg:rounded-md" : "",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "checkbox",
                                    id: "servicesIsShowing",
                                    name: "navCheck",
                                    onChange: function() {
                                        return onlyOne("servicesIsShowing");
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    htmlFor: "servicesIsShowing",
                                    className: "servicesIsShowing_label cursor-pointer no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 text-left lg:text-center w-full inline-block lg:flex px-5 py-3 lg:p-0 relative items-center",
                                    onClick: function() {
                                        return toggleDropdowns(false, !servicesIsShowing);
                                    },
                                    children: [
                                        "Werkstatt Services",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa-kit fa-chevron-down fa-fw text-primary text-lg align-middle relative right-0 ".concat(servicesIsShowing ? "rotate-180 transform float-right text-primary-500 ml-2" : "float-right text-primary-500 ml-2")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "grid grid-cols-2 gap-4 overflow-x-hidden",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative lg:absolute lg:shadow-lg z-[25] -ml-4 w-screen transform lg:left-[33%] lg:ml-0 lg:max-w-2xl lg:-translate-x-1/2 opacity-100 translate-y-0",
                                        id: "navServicesList",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "overflow-hidden rounded-lg shadow-lg",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "relative grid gap-x-6 gap-y-6 bg-white px-10 lg:p-8 sm:gap-x-8 grid-cols-2 lg:grid-cols-3 text-left",
                                                    children: services.map(function(service) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                            href: service.href,
                                                            title: service.name,
                                                            className: "col-span-2 xs:col-span-1 no-underline font-semibold text-gray-900 leading-6 flex items-center",
                                                            children: [
                                                                service.icon,
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: service.name
                                                                    }
                                                                })
                                                            ]
                                                        }, service.name);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "lg:bg-gray-50 px-12 py-4 lg:p-8",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "https://www.repareo.de/werkstatt-profilseiten/",
                                                        className: "-m-3 flow-root rounded-md py-3 md:p-3 hover:bg-gray-100 no-underline",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "fa-kit fa-garage fa-fw text-gray-700 text-2xl mr-3"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "text-base font-medium text-gray-700",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        children: "Werkst\xe4tten"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://www.repareo.de/hauptuntersuchung-hu-au/",
                                className: "no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 px-5 py-3",
                                children: "HU/AU"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: carsaleIsShowing ? " lg:text-gray-900 lg:ring-2 lg:ring-primary-500 lg:ring-offset-2 lg:outline-none lg:rounded-md" : "",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "checkbox",
                                    id: "carsaleIsShowing",
                                    name: "navCheck",
                                    onChange: function() {
                                        return onlyOne("carsaleIsShowing");
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    htmlFor: "carsaleIsShowing",
                                    className: "carsaleIsShowing_label cursor-pointer no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 text-left lg:text-center w-full inline-block lg:flex px-5 py-3 lg:p-0 relative items-center",
                                    onClick: function() {
                                        return toggleDropdowns(!carsaleIsShowing, false);
                                    },
                                    children: [
                                        "Autoankauf & Bewertung",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa-kit fa-chevron-down fa-fw text-primary text-lg align-middle float-right relative right-0 ".concat(carsaleIsShowing ? "rotate-180 transform ml-2" : "ml-2")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "grid grid-cols-2 gap-4 overflow-x-hidden",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative lg:absolute lg:shadow-lg lg:left-[60%] z-[25] w-screen lg:max-w-xs lg:-translate-x-1/2 transform sm:px-0 -ml-4",
                                        id: "navCarsaleList",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "overflow-hidden rounded-lg shadow-lg",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative grid grid-cols-2 lg:grid-cols-1 gap-6 bg-white px-10 lg:px-5 plg:y-6 sm:gap-8 pb-6 lg:p-8 text-left",
                                                children: carsale.map(function(carsaleItem) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: carsaleItem.href,
                                                        title: carsaleItem.name,
                                                        className: "col-span-2 xs:col-span-1 no-underline font-semibold text-gray-900 leading-6 flex items-center",
                                                        children: [
                                                            carsaleItem.icon,
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: carsaleItem.name
                                                                }
                                                            })
                                                        ]
                                                    }, carsaleItem.name);
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://www.repareo.de/ueber-uns-repareo/",
                                className: "no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 px-5 py-3",
                                children: "\xdcber uns"
                            })
                        })
                    ]
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderNavigation);


/***/ })

}]);